import { render } from "./flats-section.vue?vue&type=template&id=61ad871e"
import script from "./flats-section.vue?vue&type=script&lang=js"
export * from "./flats-section.vue?vue&type=script&lang=js"

import "./flats-section.vue?vue&type=style&index=0&id=61ad871e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__